// Platform detection for Helm — used to set X-Client-Platform header and
// conditionally render iOS-specific UI notices.
//
// Capacitor is NOT a build-time dependency. In remote URL mode the native
// iOS/Android shell injects the Capacitor global at runtime via WebView.
// Never `import { Capacitor } from '@capacitor/core'` — that would break CRA.

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform?: () => boolean;
      getPlatform?: () => string;
    };
  }
}

export type ClientPlatform = 'ios' | 'android' | 'web';

/**
 * Detect the current client platform.
 *
 * Priority:
 * 1. Capacitor runtime global (injected by native shell in remote URL mode)
 * 2. navigator.userAgent regex fallback (covers iOS Safari, iOS PWA)
 * 3. Default to 'web'
 */
export function detectPlatform(): ClientPlatform {
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
    const p = window.Capacitor.getPlatform?.();
    if (p === 'ios' || p === 'android') return p;
  }

  if (typeof navigator !== 'undefined') {
    const ua = navigator.userAgent || '';
    if (/(iPhone|iPad|iPod)/i.test(ua)) return 'ios';
    if (/Android/i.test(ua)) return 'android';
  }

  return 'web';
}
